module dg.objects {

    class LookupController {

        public value: dg.domain.model.DomainModelRefInfo | dg.domain.model.DomainModelRefInfo[];
        private propMeta: dg.restfulApi.DomainObjectPropertyMetadata;

        public ngModel: ng.INgModelController;
        public domainObjectCtrl: ObjectEditorController;

        private dgQueryItems: string;
        private multiple: string;
        public dataLoaded: boolean;

        private form: any;
        private propLookupData: dg.domain.model.DomainModelRefInfo[];
        private formEditor: FormEditorController;
        public shouldSelectItem: boolean = false;
        private currentState: ng.ui.IState;
        private includeNames: string[] = ['saveNamedSet', 'loadNamedSet'];
        public actionListOptions = { includeNames: this.includeNames }

        public constructor(
            private $element: ng.IAugmentedJQuery,
            private $scope: ng.IScope,
            private $state: ng.ui.IStateService, 
            private actionService: dg.actions.ActionService,
            private commandExecutedChannelService: dg.actions.CommandExecutedChannelService,
            private dgGuid: dgUtils.DgGuid,
            private listItemSelectedChannelService: dg.lists.ListItemSelectedChannelService
        ) {

        }

        $onInit() {
            // this.compile(this.$element);
            this.currentState = this.$state.current;

            if (!this.value) {
                this.propLookupData = [];
            } else {
                if (this.value instanceof Array) {
                    this.propLookupData = this.value;
                } else {
                    this.propLookupData = [this.value];
                }
            }

            this.commandExecutedChannelService.onCommandExecuted(this.$scope, c => {
                let invokeLink = c.dgMeta.links[c.dgMeta.id + '_invoke'];
                if (this.propMeta.links.add && invokeLink.urnTemplate == this.propMeta.links.add.urnTemplate) {
                    let newItemId = this.shouldSelectItem ? (c as dg.domain.commands.AggregateCommandBase).aggregateId : null;
                    this.refreshData(newItemId);
                }
            });

            this.listItemSelectedChannelService.onItemSelected(this.$scope, (item) => {
                this.changeValues(item.values);
                this.closeChildModals();
            })

            //this.ngModel.$viewChangeListeners.push(() => {
            //    this.updateViewValue(this.ngModel.$viewValue, this.ngModel.$error);
            //});

            this.initializeLinks();
        }

        private closeChildModals = () => {
            this.$state.go(this.currentState);
        }

        private changeValues = (newValues) => {
            if (this.value instanceof Array) {
                this.value.length = 0;
                newValues.forEach((val) => {
                    if (this.value instanceof Array) {
                        this.value.push(<dg.domain.model.DomainModelRefInfo>{
                            id: val,
                            displayValue: val
                        });
                    }
                });
            }
        }

        private initializeLinks() {
            if (this.propMeta.links.saveNamedSet) {
                this.propMeta.links.saveNamedSet.getDynamicParams =
                    () => {
                        let values = [];

                        
                        if (this.value) {
                            if (Array.isArray(this.value)) {
                                this.value.forEach((val) => {
                                    values.push(val.id);
                                });
                            }
                            else {
                                values.push(this.value.id);
                            }
                        }

                        return { values: values }
                    };

            }
        }
        //public updateViewValue(viewValue, error) {
        //    //this.$scope.ngModel.$setViewValue(viewValue);
        //    var currError = this.ngModel.$error;
        //    var finalError = _.assignInWith(error, currError, (objVal, sourceVal) => {
        //        return angular.isDefined(objVal);
        //    });
        //    angular.forEach(finalError, (value, key) => {
        //        this.ngModel.$setValidity(key, !value);
        //    });
        //    this.ngModel.$setDirty();
        //}

        public triggerAddItem(item) {
            this.shouldSelectItem = true;
        }

        public compile(tElement) {
            //var uiSelectChoicesElement = angular.element('ui-select-choices, *[ui-select-choices]', tElement);
            //var queryItemsExpression = uiSelectChoicesElement.attr('repeat').replace('dgQueryItems', this.dgQueryItems);
            //uiSelectChoicesElement.attr('repeat', queryItemsExpression);

        }

        public linkClick() {
            if (!this.dataLoaded) {
                this.refreshData(null);
            }
        }

        public refreshData(addedItemId) {

            if (this.propMeta.links.lookupResult && !this.propMeta.readOnly) {
                this.actionService.getQueryResult(this.propMeta.links.lookupResult.href).then((lookupData: any) => {
                    this.propLookupData = <domain.model.DomainModelRefInfo[]>lookupData.items;
                    this.fixLookupDataObjectByModel(this.propLookupData);

                    if (addedItemId) {
                        let item = this.propLookupData.filter(i => i.id == addedItemId)[0];
                        if (this.value instanceof Array) {
                            this.value.push(item);
                        } else {
                            this.value = item;
                        }
                    }
                    this.dataLoaded = true;
                }, angular.noop);
            }
        };


        //fix ngModel object equality on load
        fixLookupDataObjectByModel(propLookupDataArray: dg.domain.model.DomainModelRefInfo[]) {

            if (this.value instanceof Array) {
                if (this.value.length > 0) {
                    for (var index = 0; index < propLookupDataArray.length; ++index) {
                        let object = propLookupDataArray[index];

                        for (var modelIndex = 0; modelIndex < this.value.length; ++modelIndex) {
                            let modelObj = this.value[modelIndex];
                            if (object.id == modelObj.id) {
                                propLookupDataArray[index] = modelObj;
                                break;
                            }
                        }
                    }
                }
            }
            else {
                if (this.value) {

                    for (var index = 0; index < propLookupDataArray.length; ++index) {
                        let object = propLookupDataArray[index];
                        if (object.id == this.value.id) {
                            //propLookupDataArray[index] = this.value;
                            this.value = propLookupDataArray[index];
                            break;
                        }
                    }
                }
            }
        }
    }

    angular.module('dg.objects').component('lookup', {
        bindings: {
            value: '=ngModel', //TODO: '<'
            propMeta: '<'
        },
        require: {
            formEditor: '?^formEditor',
            ngModel: 'ngModel',
            domainObjectCtrl: '^objectEditor'
        },
        controller: LookupController,
        templateUrl: ($element, $attrs: any) => {
            return '/digmo/src/objects/properties/lookup/lookup' + (angular.isDefined($attrs.multiple) ? '-multi' : '') + '.html'
        }
    });
}